<!--GroupButtonsPanel.svelte-->
<script>
    import { panelState, alwaysVisible, togglePanel, setPanelState, getInitialState } from './GroupButtonsPanelStore.svelte';
    import { onMount } from 'svelte';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import GroupButtonsContent from './GroupButtonsContent.svelte';
    import RevenueContent from './RevenueContent.svelte';

  export let activeGroup;
  export let activeGame;
  export let groups;
  export let selectButton;
  export let slicedGroupsColors;
  export let slicedGroups1X2;
  export let antalTecken;
  export let count;
  export let inputFieldMin;
  export let inputFieldMax;
  export let infoMessages;
  export let values1X2;
  export let utd;
  export let jackpot;
  export let revenue;
  export let insats;
  export let revenueHandleClick;
  export let revenueValidateInput;
  export let revenueParseValue;
  export let formatCurrencySEK;
  export let setGroupMinMax;
  export let currentMin;
  // export let revenueValues;
  // export let updateRevenueValues;

  let heightRevenue; 

  // function isMobile() {
  //   return window.innerWidth < 768;
  // }

  // // Example usage:
  // const fontSize = isMobile() ? 14 : 18;
  // const padding = isMobile() ? '1rem' : '2rem';
  // const imageSize = isMobile() ? 'small.jpg' : 'large.jpg';

  let currentState = getInitialState();

    const getHeights = (game) => ({
        hidden: 0,
        peak: 53,
        open: 120,
        open1X2: 260,
        openRevenue: ['topptipset', 'powerplay'].includes(game) ? 310 : 210  // 300 for topptipset and powerplay, 200 for others
    });

    // Initialize heights with default game value
    let heights = getHeights(activeGame);

    // Watch for changes in activeGame and update heights accordingly
    $: if (activeGame) {
        heights = getHeights(activeGame);
        // If panel is currently in openRevenue state, update the height
        if (currentState.panelState === 'openRevenue') {
            height.set(heights.openRevenue);
        }
    }

    const height = tweened(0, {
        duration: 300,
        easing: cubicOut
    });

    $: height.set(heights[currentState.panelState]);

    onMount(() => {
        const unsubscribePanelState = panelState.subscribe(value => {
            currentState.panelState = value;
        });

        const unsubscribeAlwaysVisible = alwaysVisible.subscribe(value => {
            currentState.alwaysVisible = value;
        });

        return () => {
            unsubscribePanelState();
            unsubscribeAlwaysVisible();
        };
    });

    let startY = 0;
    let startTime = 0;
    let isDragging = false;
    let currentHeight = 0;

    const INERTIA_THRESHOLD = 0.5;
    const TRANSITION_THRESHOLD = 0.3;

    function panel_handleDragStart(event) {
        isDragging = true;
        startY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;
        startTime = Date.now();
        currentHeight = $height;
    }

    function panel_handleMove(event) {
        if (!isDragging) return;
        event.preventDefault();
        
        const currentY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;
        const dy = startY - currentY;
        
        const minHeight = currentState.alwaysVisible ? heights.peak : heights.hidden;
        currentHeight = Math.max(minHeight, Math.min(heights.open, heights[currentState.panelState] + dy));
        height.set(currentHeight, { duration: 0 });
    }

    function panel_handleEnd(event) {
        if (!isDragging) return;
        isDragging = false;

        const endY = event.type.includes('mouse') ? event.clientY : 
                     (event.changedTouches ? event.changedTouches[0].clientY : startY);
        const endTime = Date.now();
        
        const dy = startY - endY;
        const dt = endTime - startTime;
        const velocity = Math.abs(dy / dt);

        let nextState;
        let controlState = currentState.panelState;

        if (velocity > INERTIA_THRESHOLD) {
            nextState = dy > 0 ? getNextState(currentState.panelState, 1) : getNextState(currentState.panelState, -1);
        } else {
            const currentStateHeight = heights[currentState.panelState];
            const nextStateHeight = dy > 0 ? heights[getNextState(currentState.panelState, 1)] : heights[getNextState(currentState.panelState, -1)];
            const transitionPoint = currentStateHeight + (nextStateHeight - currentStateHeight) * TRANSITION_THRESHOLD;

            if ((dy > 0 && currentHeight > transitionPoint) || (dy < 0 && currentHeight < transitionPoint)) {
                nextState = dy > 0 ? getNextState(currentState.panelState, 1) : getNextState(currentState.panelState, -1);
            } else {
                nextState = currentState.panelState;
            }
        }
        setPanelState(nextState);
        selectButton(0);
    }

    function getNextState(currentState, direction) {
        const states = currentState.alwaysVisible ? ['peak', 'open'] : ['hidden', 'peak', 'open'];
        const currentIndex = states.indexOf(currentState);
        const nextIndex = Math.max(0, Math.min(states.length - 1, currentIndex + direction));
        return states[nextIndex];
    }

    function toggleOpenPeak() {
        const newState = currentState.panelState === 'peak' ? 'open' || 'openRevenue' || 'open1X2' : 'peak' ;
        setPanelState(newState);
    }
</script>

{#if activeGame !== undefined}
  <div class="panel-container">
      <div class="expandable" style="height: {$height}px;">
          <div class="handle" 
               on:mousedown={panel_handleDragStart}
               on:touchstart={panel_handleDragStart}>
              <button class="toggle-button" on:click={toggleOpenPeak}>
                  <!-- {currentState.panelState === 'open' ? 'Collapse' : 'Expand'} -->
              </button>
          </div>

        {#if currentState.panelState === 'openRevenue'}
              <button class="close-button" on:click={toggleOpenPeak}>×</button>
          <RevenueContent bind:utd={utd} bind:jackpot={jackpot} bind:revenue={revenue} bind:insats={insats} {activeGame} {revenueHandleClick} {revenueValidateInput} {revenueParseValue} {formatCurrencySEK} />
        {:else}
        <GroupButtonsContent {activeGroup} {groups} {selectButton} {slicedGroupsColors} {slicedGroups1X2} {antalTecken} {count} {inputFieldMin} {inputFieldMax} {infoMessages} {values1X2} {setGroupMinMax} {currentMin} />
        {/if}
      </div>
  </div>
{/if}

<svelte:window 
    on:mousemove={panel_handleMove}
    on:touchmove|passive={panel_handleMove}
    on:mouseup={panel_handleEnd}
    on:touchend={panel_handleEnd}
/>

<style>
    .panel-container {
/*         z-index: 20;
        background: red;
        position: fixed;
        bottom: 60pt;
        left: 0;
        right: 0;
        height: 0;
        overflow: visible; */
        width: 100%;
        background-color: var(--themeColor1);
    }
    .expandable {
 /*        flex-shrink: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0; */
        overflow: hidden;
/*         border-top: 1px solid rgba(255,255,255,0.5); */
    }
    .handle {
        height: 12pt;
/*         background-color: var(--themeColor1); */

        cursor: grab;
/*         border-bottom: 1px solid rgba(255,255,255,0.8); */
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .handle:active {
        cursor: grabbing;
    }

    .toggle-button {
        margin-top: 6pt;
        padding: 2pt 8pt;
        width: 40pt;
        height: 4pt;
        border: none;
        background-color: rgba(255,255,255,0.4);
        border-radius: 10pt;
        cursor: grabbing;
    }

    .toggle-button:hover {
        background-color: rgba(255,255,255,0.8);
    }

    .close-button {
      position: relative;
      float:  right;

  vertical-align: text-top;
    justify-content: center;
  align-items: center;
  align-self: center;
  align-content: center;
      font-size: 16pt;
        margin-top: 0pt;
        right: 12pt;
        padding: 0pt 7pt 2pt 7pt;
        background: none;
        color: var(--themeColorText);
/*         width: 40pt;
        height: 4pt;
 */        border: none;
/*         background-color: rgba(255,255,255,0.4); */
        border-radius: 12pt;
        cursor: pointer;
    }

    .close-button:hover {
      background-color: rgba(255,255,255,0.2);
    }

    .close-button:active {
      background-color: rgba(255,255,255,0.5);
      color: rgba(0,0,0,0.5);
    }

  @media (max-width: 768px) {
    .panel-container {

    }
  }

</style>